/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Filter_Key_IsInputs */

const en_filter_key_is = /** @type {(inputs: Filter_Key_IsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Is`)
};

const de_filter_key_is = /** @type {(inputs: Filter_Key_IsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ist`)
};

/**
* | output |
* | --- |
* | "Is" |
*
* @param {Filter_Key_IsInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const filter_key_is = /** @type {((inputs?: Filter_Key_IsInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Filter_Key_IsInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_filter_key_is(inputs)
	return en_filter_key_is(inputs)
});